// components/common/SectionTitle.js
import PropTypes from 'prop-types';
import React from 'react';
import { Box, Typography } from '@mui/material';
import { theme } from 'views/ConstantColors';

export const SectionTitle = ({ icon: Icon, title }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <Icon sx={{ color: theme.primary.main }} />
        <Typography variant="h6" sx={{ color: theme.primary.main, fontWeight: 600 }}>
            {title}
        </Typography>
    </Box>
);

SectionTitle.propTypes = {
    icon: PropTypes.elementType.isRequired,
    title: PropTypes.string.isRequired
};
